<template>
<v-container fluid grid-list-sm pa-0 ma-0>
  <v-layout row wrap>
  <v-flex xs12>
    
    <v-data-table v-if="listShow>0"
      :headers="headers"
      :items="listItems"
      class="elevation-1 hidden-xs-only"
      :items-per-page="10"
      >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.sl">
            <td>{{ item.sl }}</td>
            <td>{{ item.select.name }}</td>
            <td>{{ item.qty }}</td>
            <td class="hidden-sm-and-down">{{ item.select.unit }}</td>
            <td>{{ item.rate }}</td>
            <td>{{ item.gst }}</td>
            <td class="hidden-sm-and-down">{{ item.total }}</td>
            <td>{{ item.discount }}</td>
            <td>{{ item.total_wd }} </td>
            <td class="justify-center align-center px-0">
            <v-icon small class="mr-3" @click="editItem(item)">edit</v-icon>
            <v-icon small  class="" @click="deleteItem(item.index)">delete</v-icon>
            </td><v-spacer/>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-flex>
  </v-layout>

<v-layout row wrap class="hidden-sm-and-up">
  <v-flex xs12 v-for="(item, index) in listItems" :key="index">
    <v-card>
      <v-card-title>
        <v-layout><v-flex xs9>Name: {{ item.select.name }} {{ index}} </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2 >
        <v-card-actions>
         <v-icon small @click="editItem(item)">edit</v-icon>
        </v-card-actions>
         </v-flex>
         <v-flex xs1>
         <v-card-actions>
         <v-icon small  @click="deleteItem(index)">delete</v-icon>
         </v-card-actions>
        </v-flex>
        </v-layout>
      </v-card-title>
        <v-divider></v-divider>
      <v-card-title>
        <v-layout wrap>
          <v-flex xs8>Qty :</v-flex>
          <v-flex xs4 class="text-xs-right">{{item.qty}}</v-flex>

          <v-flex xs8>Price :</v-flex>
          <v-flex xs4 class="text-xs-right">{{item.rate}}</v-flex>

          <v-flex xs8>Total :</v-flex>
          <v-flex xs4 class="text-xs-right">{{item.total}}</v-flex>

          <v-flex xs8>Discount :</v-flex>
          <v-flex xs4 class="text-xs-right">{{item.discount}}</v-flex>

          <v-flex xs8>Total After Disc. :</v-flex>
          <v-flex xs4 class="text-xs-right">{{item.total_wd}}</v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
  </v-flex>
</v-layout> 

<v-layout row wrap>
  <v-flex>

  </v-flex>
</v-layout>

</v-container>


</template>
<script>
export default {
  data () {
    return {
      headers: [
      {
      text: 'Sl.',
      align: 'left',
      sortable: false,
      
      },
      {
        text: 'Description',
        align: 'left',
        sortable: false,
        
      },
      { text: 'Quantity', sortable: false, },
      { text: 'Unit', sortable: false,  class:"hidden-sm-and-down" },
      { text: 'Rate', sortable: false,  },
     // { text: 'CGST', sortable: false, width: '2%', class:"hidden-sm-and-down" },
     // { text: 'SGST', sortable: false, width: '2%', class:"hidden-sm-and-down" },
      { text: 'GST', sortable: false , },
      { text: 'Total without Discount',  sortable: false, class:"hidden-sm-and-down" },
      { text: 'Discount', sortable: false,  },
      { text: 'Total', sortable: false , },
      { text: 'Actions', sortable: false, width: '50px' }
      ],
    }
  },
  computed: {
    listItems() {
     //console.log(this.$store.state.invoice.list)
      return this.$store.state.invoice.list
    },
    listShow() {
      return this.$store.state.invoice.list.length
    },
     tax () {
     console.log( 'fom tax ' + JSON.stringify(this.$store.state.invoice.tax))
    return this.$store.getters['invoice/taxCal']
  }
  },
  methods: {
    editItem(item) {
      this.$store.dispatch('invoice/editItem',item)
    },
    deleteItem(index) {
      this.$store.dispatch('invoice/deleteItem',index)
    }
  }
}
</script>
